<template>
  <div class="check_form">
    <div v-wechat-title="$tm('index2024.form.text')" />

    <GcSkeleton :is-show="loading" />
    <GcGuide :down-show="guideShow" @showDwon="getGuideStatus" />
    <div class="form">
      <h3 class="font_bold">{{ $tm('index2024.home.title') }}</h3>

      <div class="order">
        <!-- 奖品图片 -->
        <img :src="gift.goods_img" alt="" class="rds4">
        <!-- 奖品信息 -->
        <div>
          <h2 class="font_bold text_overflow3">{{ gift.goods_title }}</h2>
          <span>{{ $tm('index2024.form.text8') }}×1</span>
        </div>
      </div>
      <div class="gray_line" />
      <van-cell-group>
        <van-field
          v-model="address.receiver"
          label-width="94px"
          :label="$tm('index2024.form.text1')[0]"
          :placeholder="$tm('index2024.form.text1')[1]"
        />
        <van-field
          v-model="address.phone"
          label-width="94px"
          type="number"
          :label="$tm('index2024.form.text2')[0]"
          :placeholder="$tm('index2024.form.text2')[1]"
        />
        <van-field
          v-model="addressName"
          label-width="94px"
          readonly
          :label="$tm('index2024.form.text3')[0]"
          :placeholder="$tm('index2024.form.text3')[1]"
          right-icon="arrow"
          @click="addressShow = true"
        />
        <van-field
          v-model="address.address"
          label-width="94px"
          rows="3"
          autosize
          :label="$tm('index2024.form.text4')[0]"
          type="textarea"
          :placeholder="$tm('index2024.form.text4')[1]"
        />
      </van-cell-group>
      <div class="gray_line" />

    </div>
    <div class="submit_btn" @click="setDialogCheckFormShow">{{ $tm('index2024.form.text9') }}</div>

    <AddressList
      v-if="addressListShow"
      :show-back="[address.country_id, address.province_code, address.city_code]"
      :is-show="addressShow"
      @getAddress="getAddress"
      @getAddressShow="getAddressShow"
    />

    <van-dialog
      v-model="sizeShow"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <img class="size_img" :src="sizeImg">
      <span class="size_close" @click="sizeShow = false" />
    </van-dialog>

    <van-dialog
      v-model:show="dialogCheckForm"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="dialog_check_form rds4">
        <h2 class="fw_bold">{{ $tm('index2024.form.text10') }}</h2>
        <ul class="form_list">
          <li><span class="font_bold">{{ $tm('index2024.form.text1')[0] }}：</span>{{ address.receiver }}</li>
          <li><span class="font_bold">{{ $tm('index2024.form.text2')[0] }}：</span>{{ address.phone }}</li>
          <li><span class="font_bold">{{ $tm('index2024.form.text4')[0] }}：</span>{{ addressName }} {{ address.address }}</li>
          <li v-if="dataInfo.is_show_size_t"><span class="font_bold">{{ $tm('index2024.form.text5')[0] }}：</span>{{ remark_t }}</li>
          <li v-if="dataInfo.is_show_size_chef_uniform"><span class="font_bold">{{ $tm('index2024.form.text6')[0] }}：</span>{{ remark_chef_uniform }}</li>
        </ul>
        <div class="submit_btn" @click="submit">{{ $tm('index2024.form.text11') }}</div>
        <div class="no_submit" @click="dialogCheckForm = false">{{ $tm('index2024.form.text12') }}</div>
      </div>

    </van-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant'
import utils from '@/utils/utils'
import { ajaxHttp } from '@/api/api'
import AddressList from '@/components/addressList.vue'
import GcGuide from '@/components/gc-guide'
import GcSkeleton from '@/components/gc-skeleton'

export default {
  name: 'CheckForm',
  components: {
    AddressList,
    GcGuide,
    GcSkeleton
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    utils.hideShare('0')
    next()
  },
  data() {
    return {
      loading: true, // 接口loading效果
      guideShow: false, // 微信点击的引导提示框
      sizeShow: false,
      addressListShow: false,
      dialogCheckForm: false,
      addressShow: false,
      pathInfo: {},
      dataInfo: {},
      address: {
        country_id: '',
        country_name: '',
        province_code: '',
        province_name: '',
        city_code: '',
        city_name: '',
        address: '',
        receiver: '',
        phone: ''
      }, // 地址信息
      remark_t: '',
      remark_chef_uniform: '',
      gift: {}, // 礼物信息
      order_type: {}, // 订单信息
      addressName: '',
      sizeImg: 'https://static.mingchu.co/webapp/index2022/size_t.png'
    }
  },
  computed: {
    // isPreview() { return this.pathInfo.status === '1' }
  },
  created() {
    const { query } = this.$route
    this.pathInfo = query
    // console.log('dada', query)
    // if (query.status === '1') {
    //   this.getPreviewData()
    // } else { this.getListData() }

    this.getListData()
    utils.hideShare()
  },
  methods: {
    setDialogCheckFormShow() {
      if (!this.address.receiver) { return Toast(this.$tm('index2024.form.text1')[1]) }
      if (!this.address.phone) { return Toast(this.$tm('index2024.form.text2')[1]) }
      if (!this.address.country_id) { return Toast(this.$tm('index2024.form.text3')[1]) }
      if (!this.address.address) { return Toast(this.$tm('index2024.form.text4')[1]) }
      if (this.dataInfo.is_show_size_t && !this.remark_t) { return Toast(this.$tm('index2024.form.text5')[1]) }
      if (this.dataInfo.is_show_size_chef_uniform && !this.remark_chef_uniform) { return Toast(this.$tm('index2024.form.text5')[1]) }
      this.dialogCheckForm = true
    },
    // 提交
    submit() {
      const self = this
      Toast.loading({ message: 'Loading...', forbidClick: true })

      ajaxHttp.$post('/api/ranking2024/order', {
        ...self.pathInfo,
        ...{ address: self.address },
        ...{ order_type: self.order_type },
        remark_t: self.remark_t,
        remark_chef_uniform: self.remark_chef_uniform,
      }).then(res => {
        if (res.code === 1) {
          self.dialogCheckForm = false
          setTimeout(() => {
            Toast.clear()
            self.pathInfo.status = '1'
          })

          Toast(`${JSON.stringify({ ...self.pathInfo, status: 1 })}`)

          // 跳转至详情页面
          this.$router.push({ path: '/2024mc/topDetail', query: { ...self.pathInfo }})
        } else {
          Toast(res.message)
        }
      })
    },
    // 获取列表数据
    getListData() {
      const self = this
      ajaxHttp.$get(
        '/api/ranking2024/gift', 
        { ...self.pathInfo }
      ).then(res => {
        if (res.code === 1) {

          this.dataInfo = res.data
          this.address = res.data.address
          this.gift = res.data.gift
          this.order_type = res.data.order_type

          if (!res.data.address.country_name) {
            this.addressName = ''
          } else {
            this.addressName = `${res.data.address.country_name || ''} ${res.data.address.province_name || ''} ${res.data.address.city_name || ''}`
          }
        } else {
          Toast(res.message)
        }
        this.$nextTick(() => {
          self.addressListShow = true
          self.loading = false
        })
      })
    },
    // 获取预览数据
    // getPreviewData() { 
    //   const self = this
    //   ajaxHttp.$get('/api/ranking2024/order_info', { ...self.pathInfo }).then(res => {
    //     if (res.code === 1) {
    //       const { address, gift, order_type } = res.data
    //       this.dataInfo = res.data
    //       this.address = address
    //       this.gift = gift
    //       this.order_type = order_type
    //       if (!res.data.address.country_name) {
    //         this.addressName = ''
    //       } else {
    //         this.addressName = `${res.data.address.country_name || ''} ${res.data.address.province_name || ''} ${res.data.address.city_name || ''}`
    //       }
    //     } else {
    //       Toast(res.message)
    //     }
    //     this.$nextTick(() => {
    //       self.addressListShow = true
    //       self.loading = false
    //     })
    //   })
    // },
    getAddressShow(isShow) {
      this.addressShow = isShow
      console.log('接收到的展示状态', isShow)
    },
    getAddress($info) {
      this.addressName = `${$info[0].label || ''} ${$info[1].label || ''} ${$info[2].label || ''}`
      this.address.country_name = $info[0].label || ''
      this.address.province_name = $info[1].label || ''
      this.address.city_name = $info[2].label || ''
      this.address.country_id = $info[0].id || ''
      this.address.province_code = $info[1].id || ''
      this.address.city_code = $info[2].id || ''

      console.log('接收到的', $info)
    },
    getGuideStatus(val) { // 获取子组件的返回
      this.guideShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
@function r($px){  // 适配 375px宽
	@return $px*(1/37.5)*1rem;
}
.preview_info{padding: r(16) 0 ; margin: 0 r(16); border-top: r(0.5) solid #e5e5e5;}
.order{padding: r(16) r(18) !important;}
// .font_bold{border-bottom: none !important;}
.title{font-size: r(18); margin-bottom: r(10);}
.label{font-size: r(16); padding: r(0) 0; line-height: r(32); color: #666; i{color: #333;}}
.form_list {
  margin-top: r(14);
}
.form {
  width: 100%;
  overflow: hidden;
}
</style>

